import React, { Component } from 'react'
import store from '../../stores/storeConfig'
import * as action from '../../stores/actionsList'
import HttpServices from '../../utils/Http.services'
import { imageAddress, playSound } from '../../utils/useful'

export default class VoiceCall extends Component {
    state = {
        videocall: { profile: '/assets/images/avatar-voice-call.jpg', name: 'Hossein Mohseni' },
        awnsered: false
    }
    answerVideoCall = (video) => {
        console.log('firstthis.props', this.props)
        let path = ['rooms', this.props.data.applet, this.props.data.frame, this.props.data?.room]
        let page = { type: "rooms", path };
        let data = { ...this.props.data }
        console.log("this.props.data", this.props.data)
        data.accept = true
        console.log('pagechaeck', page)
        HttpServices.request('acceptCall', data, (fetchResult, fetchError) => {
            this.setState({ awnsered: true })
            this.props.addNewWindow(page.type, page, "center");
            let query = ''
            if (this.props.data.kind == 'video') {
                query = '?videoCall=true'
            }
            else {
                query = '?videoCall=false'
            }
            if (!video) {
                query = query + '&&video=false'
            }
            // window.history.pushState(null, null, query)
            setTimeout(() => {
                store.dispatch(action.removeRoomInvite([this.props.data]))
            }, 50);
        })

    }
    rejectVideoCall = () => {
        let data = this.props.data
        this.setState({ awnsered: true }, () => {

            store.dispatch(action.removeRoomInvite([data]))
        })

    }
    mutedVideo = () => {

    }
    componentDidMount() {
        this.checkAnswer()
        this.playSound()
    }
    componentWillUnmount() {
        this.setState({ awnsered: true })

    }
    playSound = () => {
        console.log('playsound')
        if (!this.state.awnsered) {
            console.log('playsound', true)
            // setTimeout(() => {
            playSound('ok')
            setTimeout(() => {
                this.playSound()
            }, 1500);
            // this.playSound()
            // }, 3000);
        }
    }
    checkAnswer = () => {
        let data = this.props.data
        console.log('data is pp', data)
        setTimeout(() => {
            store.dispatch(action.removeRoomInvite([data]))
            this.setState({ awnsered: true })

        }, 30000);
    }
    render() {
        let videocall = this.state.videocall
        return (
            <div className='voice-call flexcc br-20 blur-bg box-shadow-widgets p-2'>
                <div className='flexcb w-100'>
                    <div className='flexcc'>
                        <div className='img-container br-10'>
                            <img className='br-15 w-100 h-100' style={{ objectFit: this.props.videoCall && "cover" }} src={imageAddress(this.props.data?.sender?.image, 'profile')} alt="" />
                        </div>
                        <div className='mld-3'>
                            <p className='font-size-15 weight-500' style={{ color: "#555", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: "140px" }}>{this.props.data?.sender?.fullname}</p>
                            <p className='font-size-10 color-green mt-1'>{this.props.videoCall ? 'Incoming video Call' : 'Incoming voice Call'}</p>
                        </div>
                    </div>
                    <div className='flexc'>
                        {!this.props.videoCall && (
                            <button className='flexcc' onClick={() => this.rejectVideoCall()}>
                                <img width={35} height={35} className='br-50 mx-2' src="/assets/icons/widgets/end-call.svg" alt="" />
                            </button>
                        )}
                        <button className='flexcc' onClick={() => this.answerVideoCall(true)}>
                            <img width={35} height={35} className='br-50' src="/assets/icons/widgets/videocall.svg" alt="" />
                        </button>
                        {this.props.videoCall && (
                            <>
                                <button className='flexcc mx-2' onClick={() => this.rejectVideoCall()}>
                                    <img width={35} height={35} className='br-50' src="/assets/icons/widgets/end-call.svg" alt="" />
                                </button>
                                <button className='flexcc' onClick={() => this.answerVideoCall(false)}>
                                    <img width={35} height={35} className='br-50' src="/assets/icons/widgets/videocall-mute.svg" alt="" />
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
